import React, { useEffect } from 'react';

import { observer } from 'mobx-react';

import { OrderDetailsBlock } from './OrderDetailsBlock/OrderDetailsBlock';
import { angularizeWithProviders } from '../../../shared/providers';
import { challengeCheckoutStore } from '../../stores/challengeCheckoutStore';
import { pathQueryParams } from '../../constants/pathQueryParams';
import { getRouteParam } from '../../../shared/utils/angularUtils';
import { ScrollDownBadge } from '../../components/checkout/ScrollDownBadge/ScrollDownBadge';
import { PaymentBlock } from './PaymentBlock/PaymentBlock';
import { usePromoPriceLimited } from '../../hooks/usePromoPriceLimited';
import { CheckoutContainer } from '../../components/checkout/CheckoutContainer/CheckoutContainer';

const NgzChallengeCheckout = observer(() => {
  const participantId = getRouteParam(pathQueryParams.participantId);

  const { challengeCheckoutInfo, subscribeToChallenge, setDefaultValues } =
    challengeCheckoutStore;

  usePromoPriceLimited({
    promoPrice: challengeCheckoutInfo?.challenge.pricePromo,
    finalPrice: challengeCheckoutInfo?.challenge.priceFinal,
  });

  useEffect(() => {
    subscribeToChallenge(participantId);

    return setDefaultValues;
  }, []);

  return (
    <CheckoutContainer>
      <OrderDetailsBlock />
      <ScrollDownBadge />
      <PaymentBlock />
    </CheckoutContainer>
  );
});

angularizeWithProviders(NgzChallengeCheckout, 'ngzChallengeCheckout', {});
